
const firebaseConfig = {
  "apiKey": "AIzaSyCyLcizf9QKMVpWOjslIPXBI7Bw82rLZrY",
  "authDomain": "ggc-notification-service.firebaseapp.com",
  "projectId": "ggc-notification-service",
  "storageBucket": "ggc-notification-service.firebasestorage.app",
  "messagingSenderId": "381100554318",
  "appId": "1:381100554318:web:46dabeb70e005b74746b1f",
  "vapidKey": "BDj6C2HiucN5Xl8224sNxzco_G_YBRNgNTMSgeA6imkSAxzuMIhsO7Pqmj93msShScI-Nu7yPkwlg2CX5OcIZ_A",
  "measurementId": "G-5037J4RQWT",
  "appVersion": "1.0.0"
}

export const defaultConfig = {

  //Bt Server
  // baseAPIUrl: "http://192.168.0.48:5050/api/",
  baseAPIUrl: "https://ggcapi.etrueconcept.com/api/",
  firebase: firebaseConfig,
  
};

if (typeof module !== "undefined" && module.exports) {
  module.exports = { defaultConfig, firebaseConfig };
}